import { Heading } from "@chakra-ui/react";

export default function H1({ children, ...rest }) {
  return (
    <Heading as="h1" fontWeight="bold" fontSize="2.4rem" {...rest}>
      {children}
    </Heading>
  );
}
